import { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { openModalWithTimeout } from '../store/alertSlice';
import { complainReplyActions } from '../store/complainReplySlice';
import { useReplyToComplaintMutation } from '../store/services/complaintsServices';
import { LuArrowLeft, LuSend, LuX } from "react-icons/lu";
import { complaintViewActions } from '../store/complaintViewSlice';

const customStyles = {
    content: {
        position: 'static',
        borderRadius: '10px',
        padding: 0,
        maxWidth: 'calc(100vw - 2rem)',
    },
    overlay: {
        background: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
};

Modal.setAppElement(document.getElementById('root'))

const DEFAULT_REPLY_TITLE = 'Përgjigje ndaj ankuesit'

export default function ReplyComplain() {

    const data = useSelector(state => state.complain_reply.data)
    const dispatch = useDispatch()
    const isOpen = useSelector(state => state.complain_reply.isOpen)
    const [errors, setErrors] = useState({})
    const [sendReply, { isLoading }] = useReplyToComplaintMutation();

    console.log({ data })

    const [title, setTitle] = useState(DEFAULT_REPLY_TITLE)
    const [body, setBody] = useState('')

    useEffect(() => {
        if (isOpen) setTitle(DEFAULT_REPLY_TITLE)
    }, [isOpen])

    function closeModal() {
        setTitle('')
        setBody('')
        setErrors({})
        dispatch(complainReplyActions.closeModal())
    }

    const handleCancel = () => {
        setTitle('')
        setBody('')
        setErrors({})
        dispatch(complainReplyActions.closeModal())
        dispatch(complaintViewActions.openModal(data))
    }

    const validateForm = () => {
        let formErrors = {};
        if (!title) formErrors.title = "Title is required";
        if (!body) formErrors.body = "Body is required";

        setErrors(formErrors);

        return Object.keys(formErrors).length === 0;
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        const notificationData = {
            notification: {
                title: title,
                body: body.replace(/<\/?[^>]+(>|$)/g, ""),
                data: {
                    userIds: [data.complaint_user_id],
                    complaint_id: data.complaint_id
                },
            }
        };

        if (validateForm()) {
            console.log({ notificationData })
            try {
                const formData = new FormData();

                formData.append('notification', JSON.stringify(notificationData))
                const result = await sendReply(notificationData).unwrap();
                console.log('Reply sent!', result);
                dispatch(openModalWithTimeout({ text: 'Reply was sent successfully!', type: 'success' }, 3000));
                closeModal()
            } catch (error) {
                dispatch(openModalWithTimeout({ text: error.data.message, type: 'error' }, 3000));
                console.error('Failed to send notification:', error);
            }
        } else {
            console.log("Validation errors");
        }
    };


    return (
        <div>
            <Modal
                isOpen={isOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div className="bg-white p-4 sm:p-6 w-[960px] max-w-full max-h-[90dvh] overflow-y-auto md:overflow-hidden grid md:grid-cols-2 grid-cols-1 gap-4 md:gap-6">
                    <div className='hidden md:flex flex-col gap-4 max-h-[calc(90dvh-3rem)] overflow-y-auto pr-4 border-r border-gray-200 text-sm break-words'>
                        <div className='font-bold text-base sm:text-lg text-center'>Detajet e ankesës</div>
                        <div><span className='font-bold'>Tipi i ankesës</span>: {data?.complaint_type}</div>
                        <div className='flex flex-col gap-1'>
                            <div className='font-bold'>Të dhënat e qytetarit</div>
                            <div><span className='font-semibold'>Emri dhe mbiemri: </span>{data?.complaint_user_fullname}</div>
                            <div><span className='font-semibold'>Email: </span>{data?.complaint_user_email}</div>
                        </div>
                        {data?.receipt_id && (
                            <div className='flex flex-col gap-1 p-2 bg-gray-100 rounded-md'>
                                <div><span className='font-semibold'>NUI: </span>{data?.NUI}</div>
                                <div><span className='font-semibold'>Numri i kuponit: </span>{data?.coupon_id}</div>
                                <div><span className='font-semibold'>Emri i biznesit: </span>{data?.business_name}</div>
                            </div>
                        )}
                        {data?.game_title && (
                            <div className='flex flex-col gap-1 p-2 bg-gray-100 rounded-md'>
                                <div><span className='font-semibold'>Loja: </span>{data?.game_title}</div>
                                <div><span className='font-semibold'>Tipi i lojës: </span>{data?.game_type}</div>
                            </div>
                        )}
                        <div><span className='font-semibold'>Data e dorëzimit: </span>{data?.created_at}</div>
                        <div className='flex flex-col gap-1'>
                            <div className='font-bold text-base'>{data?.complaint_title}</div>
                            <div className='whitespace-pre-wrap break-words'>{data?.complaint_body}</div>
                        </div>
                    </div>
                    <div className='flex flex-col'>
                        <div className='mb-4 md:mb-8 font-bold text-base sm:text-lg text-center'>Përgjigje e ankesës</div>
                        <div className='flex flex-col gap-4 w-full'>
                            <div className='flex flex-col gap-1'>
                                <input
                                    type='text'
                                    placeholder='Titulli'
                                    className='border border-gray-300 p-3 w-full rounded-lg text-sm'
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                />
                                {errors.title && <div className='text-sm text-red-600 font-semibold'>{errors.title}</div>}
                            </div>
                            <div className='flex flex-col gap-1'>
                                <textarea
                                    type='text'
                                    autoFocus
                                    placeholder='Përgjigje'
                                    className='border border-gray-300 p-3 h-40 sm:h-64 w-full rounded-lg text-sm resize-none outline-none'
                                    value={body}
                                    onChange={(e) => setBody(e.target.value)}
                                />
                                {errors.body && <div className='text-sm text-red-600 font-semibold'>{errors.body}</div>}
                            </div>
                            <div className="flex flex-col-reverse sm:flex-row justify-between mt-2 gap-2 sm:gap-4 text-sm font-semibold">
                                <div className="flex items-center justify-center w-full gap-2 p-2 px-6 rounded-xl cursor-pointer bg-primary/5"
                                    onClick={handleCancel}>
                                    <span><LuArrowLeft size={18} /></span>
                                    <span>Prapa</span>
                                </div>
                                <div className="p-2 px-6 bg-secondary w-full text-white rounded-xl cursor-pointer flex items-center justify-center gap-2 hover:bg-secondary/80"
                                    onClick={handleFormSubmit}
                                >
                                    <span><LuSend size={18} /></span>
                                    <span>Dërgo</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>)
}